import { Component } from '@angular/core';

@Component({
  selector: 'app-paste-small',
  templateUrl: './paste-small.component.html',
  styleUrls: ['./paste-small.component.scss']
})
export class PasteSmallComponent {

}
